exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nselect:required:invalid {\n    color: lightgray;\n}\noption[disabled] {\n}\noption {\n    color: #000;\n}\n", ""]);

// exports
